// extracted by mini-css-extract-plugin
export var redoItem = "_kr-1";
export var redoTrigger = "_kr-0";